import m from "mithril";
export class Separator {
    view() {
        return (m("article", { class: "newsletter-banner mv5" },
            m("div", { class: "newsletter-banner__textbox" },
                m("p", null, "Aktuelle Infos, Schn\u00E4ppchen und Aktionen immer mit als erstes erfahren!"),
                m("p", null,
                    m("a", { href: "https://www.phoenixreisen.com/phoenix-reisen-newsletter-anmeldung.html" },
                        m("i", { class: "fas fa-angle-right" }),
                        " Newsletter abonnieren")))));
    }
}
export default Separator;
